import { render, staticRenderFns } from "./RelativeBusiness.vue?vue&type=template&id=7187ffa0&scoped=true"
import script from "./RelativeBusiness.vue?vue&type=script&lang=js"
export * from "./RelativeBusiness.vue?vue&type=script&lang=js"
import style0 from "./RelativeBusiness.vue?vue&type=style&index=0&id=7187ffa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187ffa0",
  null
  
)

export default component.exports